import { ApiEnum } from "../../constants/ApiEnum";
import axios, { AxiosResponse } from "axios";
import { UpdateArgs } from "../../interfaces/DossierInterface";
import { disableApiError } from "../../../app/rootReducer";
import { Dispatch } from "redux";

interface ApiDossierCreateData {
    data: {
        status: {
            message: object;
        };
    };
}

export const ApiDossierCreate = async (
    slug: string,
    dispatch: Dispatch,
    args?: UpdateArgs,
): Promise<AxiosResponse<ApiDossierCreateData>> => {
    return await axios
        .post(
            ApiEnum.DOSSIER + "/create",
            {
                data: {
                    ...args?.data,
                    registration_link: slug,
                },
            },
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            },
        )
        .then(function (response) {
            dispatch(disableApiError());
            return response;
        })
        .catch(function (error) {
            return error;
        });
};
